import { render, staticRenderFns } from "./SpecimenStateList.vue?vue&type=template&id=5e0cd996&"
import script from "./SpecimenStateList.vue?vue&type=script&lang=js&"
export * from "./SpecimenStateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports